const tableinfo = [
    {
        key: "business_code",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name",
        name: "データ名称",
        editable: false
    },
    {
        key: "item_name",
        name: "項目名",
        editable: false
    },
    {
        key: "tax_category",
        name: "課税区分",
        editable: false
    },
    {
        key: "tax_signature",
        name: "税務署名",
        editable: false
    },
    {
        key: "corporate_number",
        name: "法人番号",
        editable: false
    },
    {
        key: "tax_postal_code",
        name: "納税地_郵便番号",
        editable: false
    },
    {
        key: "tax_location_furigana",
        name: "納税地フリガナ",
        editable: false
    },
    {
        key: "tax_location",
        name: "納税地",
        editable: false
    },
    {
        key: "head_office",
        name: "本店等の所在地",
        editable: false
    },
    {
        key: "phone_number",
        name: "納税地_電話番号",
        editable: false
    },
    {
        key: "merged_company_name",
        name: "被合併法人名",
        editable: false
    },
    {
        key: "representative_furigana",
        name: "代表者氏名フリガナ",
        editable: false
    },
    {
        key: "representative",
        name: "代表者氏名",
        editable: false
    },
    {
        key: "title",
        name: "役職名",
        editable: false
    },
    {
        key: "jurisdiction",
        name: "所管",
        editable: false
    },
    {
        key: "necessity",
        name: "要否",
        editable: false
    },
    {
        key: "reference_number",
        name: "整理番号",
        editable: false
    },
    {
        key: "is_sent",
        name: "送付不要_区分",
        editable: false
    },
    {
        key: "financial_inst_type",
        name: "金融機関種別",
        editable: false
    },
    {
        key: "financial_inst_name",
        name: "金融機関名",
        editable: false
    },
    {
        key: "financial_inst_category",
        name: "金融機関区分",
        editable: false
    },
    {
        key: "branch_name",
        name: "本支店名",
        editable: false
    },
    {
        key: "branch_category",
        name: "本支店区分",
        editable: false
    },
    {
        key: "deposit_type",
        name: "預金種類",
        editable: false
    },
    {
        key: "deposit_type_other",
        name: "預金種類_その他",
        editable: false
    },
    {
        key: "account",
        name: "口座番号",
        editable: false
    },
    {
        key: "post_office_name",
        name: "郵便局名",
        editable: false
    },
    {
        key: "saving_num_prev",
        name: "ゆうちょ銀行の貯金記号番号_前",
        editable: false
    },
    {
        key: "saving_num_after",
        name: "ゆうちょ銀行の貯金記号番号_後",
        editable: false
    },
    {
        key: "identification",
        name: "利用者識別番号",
        editable: false
    },
    {
        key: "capital",
        name: "資本金_出資金",
        editable: false
    },
    {
        key: "business_description",
        name: "事業内容",
        editable: false
    },
    {
        key: "representative_postal_code",
        name: "代表者住所_郵便番号",
        editable: false
    },
    {
        key: "representative_address",
        name: "代表者住所",
        editable: false
    },
    {
        key: "representative_phone_number",
        name: "代表者住所_電話番号",
        editable: false
    },
    {
        key: "manager_name",
        name: "経理担当者氏名",
        editable: false
    },
    {
        key: "accountant_corp",
        name: "税理士法人名又は事務所名",
        editable: false
    },
    {
        key: "accountant_name_furigana",
        name: "税理士名フリガナ",
        editable: false
    },
    {
        key: "accountant_name",
        name: "税理士名",
        editable: false
    },
    {
        key: "office_postal_code",
        name: "事務所所在地_郵便番号",
        editable: false
    },
    {
        key: "office_location",
        name: "事務所所在地",
        editable: false
    },
    {
        key: "office_phone_number",
        name: "事務所電話番号",
        editable: false
    },
    {
        key: "accountant_association",
        name: "所属税理士会等_税理士会",
        editable: false
    },
    {
        key: "accountant_branch",
        name: "所属税理士会等_支部",
        editable: false
    },
    {
        key: "accountant_number",
        name: "所属税理士会等_登録番号",
        editable: false
    },
    {
        key: "accountant_identification",
        name: "税理士利用者識別番号",
        editable: false
    }
];

export { tableinfo };
